import axios, { AxiosError, AxiosResponse } from "axios";
import {
  partial_delivery_seller_reception_url,
  partial_delivery_seller_validation_join_url,
  partial_hub_seller_reception_url,
  partial_hub_seller_validation_join_url,
} from "../constants/urls";
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse } from "@/interfaces/Server";
import { PartialReceptionPayload } from "@/interfaces/PartialReception";
import { Attachement } from "@/interfaces/Attachement";
import { usesHubPartialValidation } from "@/utils/partial-reception";

const postPartialReception = async (
  url: string,
  data: unknown
): Promise<AxiosResponse<ServerResponse>> => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse> = await axios({
      url,
      headers: defaultHeadersWithToken(accessToken),
      data,
      method: "POST",
    });
    return response;
  } catch (error: unknown) {
    return (error as AxiosError).response as AxiosResponse<ServerResponse>;
  }
};

/**
 * Réception partielle par le livreur ou par le hub selon le rôle de
 * l'utilisateur. Seuls les articles validés sont envoyés dans detailRecepted,
 * un tableau vide signifie que la totalité des articles du retour est refusée.
 * La réponse contient l'url du PDA à faire cacheter.
 */
export async function validerReceptionPartielle(
  payload: PartialReceptionPayload
): Promise<AxiosResponse<ServerResponse>> {
  const roles = store.getState().authentication.roles;
  const receptionUrl = usesHubPartialValidation(roles)
    ? partial_hub_seller_reception_url
    : partial_delivery_seller_reception_url;

  return postPartialReception(receptionUrl, payload);
}

/**
 * Deuxième étape de la réception partielle: le PDA cacheté est joint au retour
 * pour clôturer la tournée.
 */
export async function joindreBLReceptionPartielle(
  returnNumber: string,
  attachement: Attachement
): Promise<AxiosResponse<ServerResponse>> {
  const roles = store.getState().authentication.roles;
  const validationUrl = usesHubPartialValidation(roles)
    ? partial_hub_seller_validation_join_url
    : partial_delivery_seller_validation_join_url;

  return postPartialReception(validationUrl, {
    numTournee: returnNumber,
    attachement: attachement.attachement,
    attachementName: attachement.attachementName,
  });
}
